import React from "react";
import { useLanguage } from "../contexts/LanguageContext";

/**
 * Language Switch component for toggling between English and Arabic
 * @returns {JSX.Element} - Rendered language switch toggle
 */
const LanguageSwitch: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  const handleToggle = () => {
    setLanguage(language === "en" ? "ar" : "en");
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        fontSize: "0.9rem",
        fontWeight: "500",
          color: "var(--theme-text, var(--Colors-Neutral-900, #393939))",
      }}
    >
      {/* English Label */}
      <span
        style={{
          opacity: language === "en" ? 1 : 0.6,
          transition: "opacity 0.2s ease",
        }}
      >
        English
      </span>

      {/* Toggle Switch */}
      <div
        onClick={handleToggle}
        style={{
          position: "relative",
          width: "50px",
          height: "24px",
          backgroundColor:
            language === "ar"
              ? "var(--theme-primary-action, var(--tertiary-color))"
              : "var(--theme-border-strong, #ccc)",
          borderRadius: "12px",
          cursor: "pointer",
          transition: "background-color 0.3s ease",
          display: "flex",
          alignItems: "center",
        }}
      >
        {/* Toggle Circle */}
        <div
          style={{
            position: "absolute",
            width: "20px",
            height: "20px",
            backgroundColor: "var(--theme-surface-strong, white)",
            borderRadius: "50%",
            left: language === "ar" ? "28px" : "2px",
            transition: "left 0.3s ease",
            boxShadow: "0 2px 4px var(--theme-shadow, rgba(0, 0, 0, 0.2))",
          }}
        />
      </div>

      {/* Arabic Label */}
      <span
        style={{
          opacity: language === "ar" ? 1 : 0.6,
          transition: "opacity 0.2s ease",
        }}
      >
        العربية
      </span>
    </div>
  );
};

export default LanguageSwitch;
